<template>
  <div>
    <module-card title="筛选">
      <el-form :model="searchForm" :inline="true" label-position="left">
        <el-form-item label="导入时间">
          <date-range-picker :value="importTime" @change="value => importTime = value" @getChange="dateChange"/>
        </el-form-item>
        <el-form-item label="活动编号">
          <el-input v-model="searchForm.activityId" placeholder="请输入商户编号" :clearable="true"/>
        </el-form-item>
        <el-form-item label="商户编号">
          <el-input v-model="searchForm.merchantId" placeholder="请输入商户编号" :clearable="true"/>
        </el-form-item>
        <el-form-item label="代理商编号">
          <el-input v-model="searchForm.agentId" placeholder="请输入代理商编号" :clearable="true"/>
        </el-form-item>
        <el-button type="primary" :loading="searchLoading" @click="search">查询</el-button>
        <el-button type="default" :loading="exportLoading" @click="handleExport">导出</el-button>
        <batch-import
            opt="import_merchant"
            class="batchImport"
            button-text="导入无额度商户"
            submit-name="importNoQuota"
            templateName="批量导入无额度商户模板文件"
            fail-key="failMerchantList"
            dialog-title="导入无额度商户"
            @submit="importSubmit"
            :plain="true"
            :hasIcon="false"
            :tableList="[
            { label: '商户编号', prop: 'merchantId' },
            { label: '商户简称', prop: 'merchantShortName' },
            { label: '失败原因', prop: 'errorMsg' }
            ]"/>
      </el-form>
    </module-card>

    <module-card title="无额度商户记录">
      <el-table class="table" border :data="list" v-loading="tableLoading">
        <el-table-column
          label="导入时间"
          prop="createTime"
          width="160">
        </el-table-column>
        <el-table-column
          label="活动编号"
          prop="activityId"
          width="150">
        </el-table-column>
        <el-table-column
          label="活动名称"
          prop="activityName"
          width="140">
        </el-table-column>
        <el-table-column
          label="代理商编号"
          prop="agentCode"
          width="120">
        </el-table-column>
        <el-table-column
          label="代理商名称"
          prop="agentName"
          width="160">
        </el-table-column>
        <el-table-column
          label="商户编号"
          prop="merchantCode"
          width="120">
        </el-table-column>
        <el-table-column
          label="商户简称"
          prop="merchantShortName"
          width="160">
        </el-table-column>
        <el-table-column
          label="额度包周期"
          prop="period"
          width="120">
        </el-table-column>
        <el-table-column
          label="备注内容"
          prop="remarks"
          width="150">
        </el-table-column>
        <el-table-column
          label="导入账号"
          prop="operator"
          width="120">
        </el-table-column>
        <el-table-column
          width="120"
          label="操作">
          <template slot-scope="scope">
            <div class="flex-space-around">
              <auth-button auth-type="span" opt="delete" label="删除" class="editBtn"
                           @click.native="handleDeleteRecord(scope.row)"/>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <pagination :count="total" :page-no="pageNo" :size="pageSize"
                  @changePage="value => { this.pageNo = value; getList() }"/>
    </module-card>
  </div>
</template>
<script>
import pagination from '@/components/pagination'
import dateRangePicker from '@/components/dateRangePicker'
import batchImport from '@/components/upload/batchImport'
import { downJumpConfirm } from '@/assets/js/utils'

export default {
  name: 'merchantImportRecord',
  components: {
    pagination,
    dateRangePicker,
    batchImport
  },
  data () {
    return {
      id: '',
      list: [],
      total: 0,
      pageNo: 1,
      pageSize: 10,
      tableLoading: false,
      searchForm: {
        importTimeStart: '',
        importTimeEnd: '',
        activityId: '',
        merchantId: '',
        agentId: ''
      },
      exportLoading: false,
      searchLoading: false,
      importTime: []
    }
  },
  mounted () {
    this.init()
  },
  computed: {},
  methods: {
    async init () {
      this.getList()
    },
    dateChange (value) {
      this.importTime = value
    },
    getList () {
      this.searchForm.importTimeStart = this.importTime && this.importTime[0] ? this.importTime[0] : ''
      this.searchForm.importTimeEnd = this.importTime && this.importTime[1] ? this.importTime[1] : ''
      this.tableLoading = true
      this.searchLoading = true
      const params = Object.assign({}, this.searchForm, {
        pageSize: this.pageSize,
        pageNo: this.pageNo
      })
      this.$axios.post(this.$api.noQuotaList, params).then(res => {
        if (res.respCode === '0') {
          this.list = res.data.list
          this.total = res.data.count
        }
        this.tableLoading = false
        this.searchLoading = false
      })
    },
    handleDeleteRecord (row) {
      this.$confirm('是否确认删除该商户记录', '温馨提示').then(res => {
        this.$axios.get(this.$api.deleltNoQuota + row.id).then(res => {
          if (res.respCode === '0') {
            this.$message({
              type: 'success',
              showClose: 'true',
              message: '删除成功'
            })
            this.getList()
          }
        })
      }).catch(() => {})
    },
    handleExport () {
      this.searchForm.importTimeStart = this.importTime && this.importTime[0] ? this.importTime[0] : ''
      this.searchForm.importTimeEnd = this.importTime && this.importTime[1] ? this.importTime[1] : ''
      this.exportLoading = true
      this.$axios.post(this.$api.noQuotaExport, this.searchForm).then((res) => {
        this.exportLoading = false
        if (res.respCode === '0') {
          downJumpConfirm.call(this)
        }
      })
    },
    search () {
      this.pageNo = 1
      this.getList()
    },
    importSubmit (result) {
      if (result) {
        this.getList()
      }
    }
  }
}
</script>
<style scoped>
  .table {
    margin-top: 20px;
  }

  .form-flex-item {
    margin-right: 5px;
  }

  .icon {
    width: 14px;
    height: 14px;
    text-align: center;
    font-size: 12px;
    line-height: 12px;
    border-radius: 50%;
    display: inline-block;
    background: #409EFF;
    color: #fff;
    margin-left: 12px;
    cursor: pointer;
    user-select: none; /* Standard syntax */
  }

  .form-input {
    width: 550px;
  }

  .inner-input {
    width: 240px;
  }
</style>
